import R from "ramda";
import { store } from "store";
import { reset } from "redux-form";
import { fetchUserSettings, putUserDetails, postNewPassword } from "api/user-settings";
import {
  putFavouriteAccount,
  fetchFavouriteAccount,
  fetchDefaultInterface,
  putDefaultInterface
} from "api/storage";
import { setFlashMessageAction, setFlashGenericErrorAction } from "actions/app-actions";
import { isValidEmail } from "utils/validators";
import { trackEventAction } from "actions/shared/tracking-actions";

export const SET_USER_SETTINGS = "actions/user-settings/set-user-settings";
export const UPDATE_USER_EMAIL = "actions/user-settings/update-user-email";
export const UPDATE_USER_NAME = "action/user-settings/update-user-name";
export const SET_FAVOURITE_ACCOUNT = "actions/user-settings/set-favourite-account";
export const UPDATE_FAVOURITE_ACCOUNT = "actions/user-settings/update-favourite-account";
export const UPDATE_DEFAULT_INTERFACE = "actions/user-settings/update-default-interface";
export const SET_DEFAULT_INTERFACE = "actions/user-settings/set-default-interface";
export const UPDATE_DEFAULT_INTERFACE_LOADING = "actions/user-settings/update-default-interface-loading";
export const UPDATE_DEFAULT_INTERFACE_LOADING_STOP = "actions/user-settings/update-default-interface-loading-stop";

export const fetchUserSettingsAction = () => (dispatch) => {
  fetchUserSettings()
    .then(({ email, name, surname }) => {
      dispatch({
        type: SET_USER_SETTINGS,
        data: { email, name, surname }
      });
    });
};

export const saveUserEmailAction = () => (dispatch) => {
  const state = store.getState();
  const userDetails = R.path(["form", "userEmailForm", "values"], state);
  if (userDetails.newEmail === userDetails.confirmEmail && isValidEmail(userDetails.newEmail)) {
    const email = userDetails.newEmail;
    const name = userDetails.name;
    const surname = userDetails.surname;
    return putUserDetails({ email, name, surname })
      .then(() => {
        dispatch({
          type: UPDATE_USER_EMAIL,
          data: { email }
        });
        dispatch(setFlashMessageAction("User email updated"));
        dispatch(trackEventAction("User email updated"));
      })
      .catch((error) => {
        const errorObject = error.response;
        if (errorObject.status === 422) {
          return dispatch(setFlashMessageAction(errorObject.data.reason, "error"));
        }
        return dispatch(setFlashGenericErrorAction());
      });
  }
  return dispatch(setFlashMessageAction("Emails are invalid or do not match", "error"));
};

export const saveUserNameAction = () => (dispatch) => {
  const state = store.getState();
  const userDetails = R.path(["form", "userNameForm", "values"], state);
  return putUserDetails(userDetails)
      .then(() => {
        dispatch({
          type: UPDATE_USER_NAME,
          data: { userDetails }
        });
        dispatch(setFlashMessageAction("Name updated"));
        dispatch(trackEventAction("User name updated"));
      })
      .catch(() => {
        dispatch(setFlashGenericErrorAction());
      });
};

export const saveNewPasswordAction = () => (dispatch) => {
  const state = store.getState();
  const passwordDetails = R.path(["form", "userPasswordForm", "values"], state);
  if (passwordDetails.newPassword !== passwordDetails.newPasswordRepeated) {
    dispatch(reset("userPasswordForm"));
    return dispatch(setFlashMessageAction("Passwords do not match. Please try again", "error"));
  }
  return postNewPassword(passwordDetails)
    .then(() => {
      dispatch(setFlashMessageAction("Password updated"));
      dispatch(reset("userPasswordForm"));
      dispatch(trackEventAction("Password updated"));
    })
    .catch((error) => {
      dispatch(reset("userPasswordForm"));
      const errorObject = error.response;
      if (errorObject.status === 422) {
        return dispatch(setFlashMessageAction(errorObject.data.reason, "error"));
      }
      return dispatch(setFlashGenericErrorAction());
    });
};

export const fetchFavouriteAccountAction = () => (dispatch) => (
  fetchFavouriteAccount()
    .then((response) => {
      const accountId = response || null;
      dispatch({
        type: SET_FAVOURITE_ACCOUNT,
        data: { accountId }
      });
    })
);

export const updateFavouriteAccountAction = () => (dispatch) => {
  const state = store.getState();
  const selectedAccountId = R.path(["form", "favouriteAccountForm", "values", "favouriteAccount", "key"], state);

  return putFavouriteAccount(selectedAccountId)
    .then(() => {
      dispatch({
        type: UPDATE_FAVOURITE_ACCOUNT,
        data: { selectedAccountId }
      });
      dispatch(trackEventAction("Favourite account set"));
      if (selectedAccountId) {
        dispatch(setFlashMessageAction("Favourite account saved."));
      } else {
        dispatch(setFlashMessageAction("Favourite account removed."));
      }
    });
};

export const fetchDefaultInterfaceAction = () => (dispatch) => (
  fetchDefaultInterface()
    .then((response) => {
      const isBetaDefault = response || false;
      dispatch({
        type: SET_DEFAULT_INTERFACE,
        data: { isBetaDefault }
      });
    })
);

export const updateDefaultInterfaceAction = (isBetaDefault) => (dispatch) => {
  dispatch({ type: UPDATE_DEFAULT_INTERFACE_LOADING });
  return putDefaultInterface(isBetaDefault)
    .then(() => {
      dispatch({
        type: UPDATE_DEFAULT_INTERFACE,
        data: { isBetaDefault }
      });
      if (isBetaDefault) {
        dispatch(setFlashMessageAction("Beta UI saved as default."));
        dispatch(trackEventAction("Beta UI saved as default"));
        dispatch({ type: UPDATE_DEFAULT_INTERFACE_LOADING_STOP });
      } else {
        dispatch(setFlashMessageAction("Beta UI remove as default."));
        dispatch(trackEventAction("Beta UI removed as default"));
        dispatch({ type: UPDATE_DEFAULT_INTERFACE_LOADING_STOP });
      }
    });
};



// WEBPACK FOOTER //
// ./src/js/actions/user-settings-actions.js